// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2St_U","delete":"styles_delete__P7B5x","update":"styles_update__2fgbH","add":"styles_add__wIouu"};